"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconDocumentFilled = function IconDocumentFilled(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.28 16H30.28C30.2402 16.0014 30.2006 15.9946 30.1636 15.98C30.1265 15.9654 30.0929 15.9434 30.0648 15.9152C30.0366 15.8871 30.0146 15.8535 30 15.8164C29.9854 15.7794 29.9786 15.7398 29.98 15.7V8.69999C29.9808 8.64127 29.9989 8.58409 30.0319 8.53553C30.0649 8.48697 30.1115 8.44916 30.1658 8.4268C30.2201 8.40444 30.2797 8.39851 30.3374 8.40974C30.395 8.42098 30.4481 8.44888 30.49 8.48999L37.49 15.49C37.5311 15.5319 37.559 15.585 37.5703 15.6426C37.5815 15.7003 37.5756 15.7599 37.5532 15.8142C37.5308 15.8685 37.493 15.9151 37.4445 15.9481C37.3959 15.9811 37.3387 15.9992 37.28 16Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7 18H28.3C28.2602 18.0014 28.2206 17.9946 28.1836 17.98C28.1465 17.9654 28.1129 17.9434 28.0848 17.9152C28.0566 17.8871 28.0346 17.8535 28.02 17.8164C28.0054 17.7794 27.9986 17.7398 28 17.7V8.3C28.0014 8.26022 27.9946 8.22059 27.98 8.18356C27.9654 8.14653 27.9434 8.1129 27.9152 8.08476C27.8871 8.05662 27.8535 8.03457 27.8164 8.01999C27.7794 8.0054 27.7398 7.9986 27.7 8H12.3C12.2602 7.9986 12.2206 8.0054 12.1836 8.01999C12.1465 8.03457 12.1129 8.05662 12.0848 8.08476C12.0566 8.1129 12.0346 8.14653 12.02 8.18356C12.0054 8.22059 11.9986 8.26022 12 8.3V41.7C11.9986 41.7398 12.0054 41.7794 12.02 41.8164C12.0346 41.8535 12.0566 41.8871 12.0848 41.9152C12.1129 41.9434 12.1465 41.9654 12.1836 41.98C12.2206 41.9946 12.2602 42.0014 12.3 42H37.7C37.7398 42.0014 37.7794 41.9946 37.8164 41.98C37.8535 41.9654 37.8871 41.9434 37.9152 41.9152C37.9434 41.8871 37.9654 41.8535 37.98 41.8164C37.9946 41.7794 38.0014 41.7398 38 41.7V18.3C38.0014 18.2602 37.9946 18.2206 37.98 18.1836C37.9654 18.1465 37.9434 18.1129 37.9152 18.0848C37.8871 18.0566 37.8535 18.0346 37.8164 18.02C37.7794 18.0054 37.7398 17.9986 37.7 18Z",
    fill: color
  }));
};

IconDocumentFilled.defaultProps = {
  color: 'black',
  size: 30
};
IconDocumentFilled.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string
};
var _default = IconDocumentFilled;
exports.default = _default;